import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createWSClient, loggerLink, wsLink } from '@trpc/client';
import 'flowbite';

import React, { useState } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import superjson from 'superjson';

import { trpc } from '../utils/trpc';
import { Blank } from './Blank';
import DevEnvs from './envs/DevEnvs';
import { Navigation } from './Navigation';
import Optimizer from './optimizer/Optimizer';
import { ProtectedRoute } from './ProtectedRoute';

const App = () => {
  const [queryClient] = useState(() => new QueryClient());
  const [trpcClient] = useState(() => {
    const wsServer = window.location.hostname === 'localhost' ? 'ws://localhost:4001/ws' : 'wss://dev.bioplan.ai/ws';
    const wsClient = createWSClient({ url: wsServer });
    return trpc.createClient({
      links: [loggerLink(), wsLink({ client: wsClient })],
      transformer: superjson
    });
  });

  return (
    <trpc.Provider queryClient={queryClient} client={trpcClient}>
      <QueryClientProvider client={queryClient}>
        <div>
          <div className="flex flex-row">
            <div className="grow">
              <Navigation />
            </div>
          </div>
          <Routes>
            <Route path="/">
              <Route index element={<ProtectedRoute component={Blank} />} />
              <Route path="prod/*" element={<ProtectedRoute component={Blank} />} />
              <Route path="optimizer/*" element={<ProtectedRoute component={Optimizer} />} />
              <Route path="dev/*" element={<ProtectedRoute component={DevEnvs} />} />
            </Route>
          </Routes>
          <Outlet />
        </div>
      </QueryClientProvider>
    </trpc.Provider>
  );
};

export default App;
